import { Observable } from 'rxjs';
import { CityDetailsResponse } from '../models/city-details.model';

export abstract class CityDetailsRepository {
    abstract getCityDetails(url: string): Observable<CityDetailsResponse>;
}
